import { AnimateOnScroll } from "../../../components/animate";
import { AnimateWordsOnScroll } from "../../../components/animate/animateWords";
import { FloatY } from "../../../components/animate/floatY";

export const CtaSection = ({ onCreateEvent }: { onCreateEvent: () => void }) => {
  return (
    <section className="max-width-website py-12 md:py-16">
      <div className="relative">
        <div className="relative overflow-hidden rounded-[28px] bg-ink px-6 py-[100px] md:px-[100px]">
          <div className="pointer-events-none absolute left-1/2 top-[150px] h-[929px] w-[929px] -translate-x-1/2 rounded-full bg-[#A6E2F4]/30 blur-[150px]" />

          <div className="relative mx-auto flex w-full max-w-[400px] flex-col items-center gap-10 text-center">
            <div className="flex flex-col gap-4">
              <AnimateWordsOnScroll
                as="h2"
                className="font-dela text-[32px] leading-[36px] tracking-[-0.64px] text-[#A6E2F4] md:text-[40px] md:leading-[42px] md:tracking-[-0.8px]"
              >
                Ready to host your next event?
              </AnimateWordsOnScroll>
              <AnimateOnScroll animation="blur-up" delay={0.4}>
                <p
                  className="font-onest text-[18px] leading-[24px] tracking-[-0.36px] text-white md:text-[20px] md:leading-[28px] md:tracking-[-0.4px]"
                  style={{ fontFeatureSettings: '"ss01" 1' }}
                >
                  Every great community starts with someone deciding to bring
                  people together.
                </p>
              </AnimateOnScroll>
            </div>

            <AnimateOnScroll animation="blur-up" delay={0.5}>
              <button
                type="button"
                onClick={onCreateEvent}
                className="rounded-full bg-[#F3F3F4] px-[18px] py-3 font-onest text-[16px] font-medium leading-[20px] tracking-[-0.48px] text-ink transition-transform duration-300 hover:-translate-y-0.5"
              >
                Create your event
              </button>
            </AnimateOnScroll>
          </div>
        </div>

        <FloatY
          direction="up"
          duration={9}
          className="pointer-events-none absolute left-[-115px] top-[-88px] md:left-[-15px]"
        >
          <img
            src="/assets/images/landing-cta-location-pin.png"
            alt=""
            aria-hidden
            className="h-[253px] w-[253px] md:h-[320px] md:w-[320px]"
          />
        </FloatY>
        <FloatY
          direction="down"
          duration={10}
          delay={0.7}
          className="pointer-events-none absolute right-[-141px] top-[333px] md:right-[-22px] md:top-[142px]"
        >
          <img
            src="/assets/images/landing-cta-speaker.png"
            alt=""
            aria-hidden
            className="h-[279px] w-[279px] md:h-[400px] md:w-[400px]"
          />
        </FloatY>
      </div>
    </section>
  );
};
